import React from 'react';
import { AlertCircle } from 'lucide-react';
import { EightDReport, UpdateFieldFn } from '../../types/eightd.types';

interface D0PreparationProps {
    report: Partial<EightDReport>;
    updateField: UpdateFieldFn;
}

export const D0Preparation: React.FC<D0PreparationProps> = ({ report, updateField }) => {
    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">D0: Preparation & Emergency Response</h3>
                <p className="text-sm text-gray-600 mb-6">
                    Assess the need for 8D and protect the customer immediately.
                </p>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Emergency Response Actions *
                </label>
                <textarea
                    value={report.d0_formation?.emergencyResponseActions || ''}
                    onChange={(e) => updateField('d0_formation.emergencyResponseActions', e.target.value)}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="What immediate actions were taken to protect the customer?"
                />
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <h4 className="font-medium text-yellow-800 mb-2 flex items-center gap-2">
                    <AlertCircle size={16} /> IATF Requirement
                </h4>
                <p className="text-sm text-yellow-700">
                    Immediate containment actions must be verified to ensure they stop non-conforming parts from reaching the customer.
                </p>
            </div>
        </div>
    );
};
